export default __webpack_public_path__ + "static/media/wp6291908.c8063e5f.jpg";